import React from "react";
import { Helmet } from "react-helmet";
import Loader from "../../../components/common/Loader";
import Footer from "../../../components/home1/Footer";
import Menu from "../../../components/innerpage/Menu";
import Navbar from "../../../components/home1/Navbar";
import ServiceDetail from "../../../components/innerpage/service_detail/ServiceDetail";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "../../../seoConfig";

const PAGE_TITLE = "Custom Furniture Design Services | " + SITE_NAME;
const PAGE_DESC =
  "Bespoke and modular furniture design for homes, offices, and commercial spaces — wardrobes, TV units, dining and bedroom furniture, crafted with quality materials and skilled craftsmanship.";
const PAGE_PATH = "/innerpages/services/furniture-design";

function FurnitureDesign() {
  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESC} />
        <meta
          name="keywords"
          content="custom furniture design, modular furniture, residential furniture, office furniture, wardrobes, TV units, dining furniture, bedroom furniture"
        />
        <link rel="canonical" href={`${SITE_URL}${PAGE_PATH}`} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESC} />
        <meta property="og:url" content={`${SITE_URL}${PAGE_PATH}`} />
        <meta property="og:image" content={`${SITE_URL}${DEFAULT_OG_IMAGE}`} />
        <meta property="og:site_name" content={SITE_NAME} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESC} />
        <meta name="twitter:image" content={`${SITE_URL}${DEFAULT_OG_IMAGE}`} />

        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/navbar-fix.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
        <body className="inner-pages-style1 s-project-pg-style1 service-detail-page" />
      </Helmet>
      <Loader />
      <Menu />
      <div className="smooth-scroll-content" id="scrollsmoother-container">
        <Navbar />
        <main>
          <ServiceDetail
            tag="Furniture"
            title="Furniture Design"
            intro="Furniture is more than a functional necessity — it is an extension of a space's personality and one of the defining elements of great interior design."
            heroImage="/innerpages/assets/img/services/3.png"
            // TODO: swap these 4 paths for your actual image files
            gallery={[
              "/innerpages/assets/img/services/gallery/furniture-1.jpg",
              "/innerpages/assets/img/services/gallery/furniture-2.jpg",
              "/innerpages/assets/img/services/gallery/furniture-3.jpg",
              "/innerpages/assets/img/services/gallery/furniture-4.jpg",
            ]}
            paragraphs={[
              "Our bespoke furniture design service focuses on creating pieces that seamlessly blend style, comfort, durability, and functionality while perfectly complementing the overall design language of the project.",
              "Every furniture piece is custom-designed to suit your lifestyle, available space, and aesthetic preferences. We carefully consider dimensions, ergonomics, materials, finishes, and craftsmanship to ensure each product not only looks exceptional but also delivers lasting performance.",
              "From elegant residential furniture to sophisticated office solutions and commercial installations, we create timeless pieces that maximize usability while enhancing the visual appeal of every environment. Our collaborative design process ensures every detail reflects your individual taste and project requirements.",
              "By combining quality materials with skilled craftsmanship, we deliver furniture that is built to last and designed to be appreciated for years to come.",
            ]}
            listTitle="Our Furniture Design Services"
            listItems={[
              "Custom Furniture Design",
              "Modular Furniture Solutions",
              "Residential Furniture",
              "Commercial & Office Furniture",
              "Wardrobes & Storage Systems",
              "TV Units & Feature Walls",
              "Dining & Bedroom Furniture",
              "Reception & Retail Furniture",
              "Material & Upholstery Selection",
              "Furniture Layout Planning",
            ]}
            otherServices={[
              {
                title: "Architecture & Exterior Design",
                link: "/innerpages/services/architecture-exterior-design",
              },
              {
                title: "Interior Design",
                link: "/innerpages/services/interior-design",
              },
              {
                title: "Project Consultation",
                link: "/innerpages/services/project-consultation",
              },
            ]}
          />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default FurnitureDesign;
